import {on} from 'delegated-events'
import {onKey} from '@github-ui/onfocus'
import {debounce} from '@github/mini-throttle'
import {TemplateInstance} from '@github/template-parts'
import {parseHTML} from '@github-ui/parse-html'
import {handleCopilotAllCheckbox} from './cfb-settings'

on('click', '.js-copilot-update-individual-org-enablement', async function (event) {
  const target = event.currentTarget as HTMLElement
  const form = target.closest('form') as HTMLFormElement
  const body = new FormData(form)

  body.append('enablement', target.getAttribute('data-value') || '')

  const response = await fetch(form.action, {
    method: 'PUT',
    body,
    headers: {Accept: 'text/fragment+html'},
  })

  if (response.status >= 400) {
    // eslint-disable-next-line i18n-text/no-en
    const message = 'An unknown error occurred.'
    const template = document.querySelector<HTMLTemplateElement>('template.js-flash-template')!
    template.after(new TemplateInstance(template, {className: 'flash-error', message}))
  } else {
    const replaceTarget = form.closest('[data-replace-remote-form-target]') as HTMLElement
    const partial = parseHTML(document, await response.text())
    replaceTarget.replaceWith(partial)
    target.setAttribute('aria-checked', 'true')
    updateEnabledCount(target.getAttribute('data-value') === 'enable' ? 1 : -1)
  }
})

on('click', '.js-copilot-select-all-orgs', function (event) {
  const target = event.target as HTMLInputElement

  const checkboxes = document.querySelectorAll<HTMLInputElement>('.js-copilot-org-bulk-actions-checkbox')
  let count = 0
  for (const checkbox of checkboxes) {
    // Orgs on an enterprise trial or those without copilot enable shouldn't be selectable
    if (checkbox.disabled) {
      continue
    }

    if (target.checked) {
      checkbox.checked = true
      const bulkActions = document.getElementById('enterprise-management-bulk-menu')
      bulkActions!.hidden = false
      count += 1
      const defaultTitle = document.getElementById('copilot-org-select-default-header')
      defaultTitle!.textContent = `${count} ${pluralize(count)} selected`

      trackCheckedValues(checkbox)
    } else {
      const bulkActions = document.getElementById('enterprise-management-bulk-menu')
      bulkActions!.hidden = true
      const defaultTitle = document.getElementById('copilot-org-select-default-header')
      defaultTitle!.textContent = `${count} ${pluralize(count)} selected`
      checkbox.checked = false
    }
  }
})

on('change', '.js-copilot-org-bulk-actions-checkbox', function (event) {
  const checkboxes = document.querySelectorAll<HTMLInputElement>('.js-copilot-org-bulk-actions-checkbox')
  let found = false
  let count = 0
  let totalCount = 0
  for (const checkbox of checkboxes) {
    totalCount += 1
    if (checkbox.checked) {
      const bulkActions = document.getElementById('enterprise-management-bulk-menu')
      bulkActions!.hidden = false
      count += 1
      const defaultTitle = document.getElementById('copilot-org-select-default-header')
      defaultTitle!.textContent = `${count} ${pluralize(count)} selected`

      found = true
    }
  }
  const allCheckbox = document.getElementById('select-all-checkbox') as HTMLInputElement
  handleCopilotAllCheckbox(allCheckbox, count, totalCount)

  if (found === false) {
    const bulkActions = document.getElementById('enterprise-management-bulk-menu')
    bulkActions!.hidden = true
    const defaultTitle = document.getElementById('copilot-org-select-default-header')
    // eslint-disable-next-line i18n-text/no-en
    defaultTitle!.textContent = 'Select organizations'
  }
  trackCheckedValues(event.target as HTMLInputElement)
})

const checkedValues = new Map<string, string>()
let enabledCount = parseInt(
  document.getElementById('js-copilot-enabled-count')?.getAttribute('data-enabled-count') || '0',
)

const updateEnabledCount = (change: number) => {
  enabledCount += change

  const enabledCountElement = document.getElementById('js-copilot-enabled-count')

  if (!enabledCountElement) {
    return
  }

  if (!enabledCount) {
    enabledCountElement.textContent = ''
  } else {
    enabledCountElement.textContent = `${enabledCount} ${enabledCount === 1 ? 'organization' : 'organizations'}`
  }
}

const trackCheckedValues = (target: HTMLInputElement) => {
  if (target.checked) {
    checkedValues.set(target.getAttribute('data-org-id') || '', target.getAttribute('data-enablement-status') || '')
  } else {
    checkedValues.delete(target.getAttribute('data-org-id') || '')
  }
}

const debouncedSearch = debounce(searchOrgs, 200)
onKey('keyup', '.js-copilot-organization-search', function () {
  debouncedSearch()
})

async function searchOrgs() {
  const input = document.querySelector<HTMLInputElement>('.js-copilot-organization-search')!
  let query
  if (input && input.value) {
    query = input.value
  }

  const urlParams = new URLSearchParams(window.location.search)
  urlParams.set('query', query || '')
  const url = `${window.location.pathname}?${urlParams.toString()}`
  window.history.pushState({}, '', url)
  const form = input.closest('form') as HTMLFormElement
  const body = new FormData(form)

  const response = await fetch(form.action, {
    method: 'POST',
    body,
    headers: {Accept: 'text/fragment+html'},
  })

  if (response.status >= 400) {
    // eslint-disable-next-line i18n-text/no-en
    const message = 'An unknown error occurred.'
    const template = document.querySelector<HTMLTemplateElement>('template.js-flash-template')!
    template.after(new TemplateInstance(template, {className: 'flash-error', message}))
  } else {
    const replaceTarget = document.getElementById('copilot-org-select-list-component')!
    const partial = parseHTML(document, await response.text())
    replaceTarget.replaceWith(partial)
  }
}

const setStandaloneFormButtonVisibility = (hideSubmit: boolean, hideDialog: boolean) => {
  const submitButton = document.getElementById('standalone-form-component-submit-button')
  const dialogButton = document.getElementById('dialog-show-copilot-business-settings-access-component')
  submitButton!.hidden = hideSubmit
  dialogButton!.hidden = hideDialog
}
on('click', '#standalone-form-component-radio-button-disabled', () => setStandaloneFormButtonVisibility(true, false))
on('click', '#standalone-form-component-radio-button-enabled', () => setStandaloneFormButtonVisibility(false, true))

function pluralize(count: number) {
  return count === 1 ? 'organization' : 'organizations'
}
